.disabled-section {
    opacity: 0.5;
    /* Don't allow clicks on children elements, not foolproof, just a fallback */
    pointer-events: none;
    width: 100%;
    height: 100%;
}

.disabled-section--height-fit-content {
    height: fit-content;
}
